/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbayConnectReq
 */
export interface AdminEbayConnectReq {
    /**
     * Redirect is the address of the page eBay opened after consent, or the authorization code itself.
     * @type {string}
     * @memberof AdminEbayConnectReq
     */
    redirect: string;
}

export function AdminEbayConnectReqFromJSON(json: any): AdminEbayConnectReq {
    return AdminEbayConnectReqFromJSONTyped(json, false);
}

export function AdminEbayConnectReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayConnectReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'redirect': json['redirect'],
    };
}

export function AdminEbayConnectReqToJSON(value?: AdminEbayConnectReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'redirect': value.redirect,
    };
}

